import { SizeChart } from '../../common/data.js';
import { Component } from 'preact';
import { getSizeName, PublicProduct, sizeGroups } from '../../common/data/products.js';
import { getSizeChart } from '../lib/api.js';
import { Loading } from './loading.js';

interface SizeChartTableProps {
	product: PublicProduct;
}

type Arr<T> = T[];

interface SizeChartTableState {
	size_chart: SizeChart;
	values?: Arr<[string, string[]]>;
}

export class SizeChartTable extends Component<SizeChartTableProps, SizeChartTableState> {
	
	getValues = async () => {
		
		const { size_chart } = await getSizeChart({ product: this.props.product.id });
		if (!size_chart) return;
		
		const entries = Object.entries(size_chart.values);
		
		const words = Object.keys(sizeGroups);
		
		const values
			= entries.sort(([word, nums], [nextWord, nextNum]) => {
				const firstWord = words.indexOf(word.split('-')[0]!);
				const secondWord = words.indexOf(nextWord.split('-')[0]!);
				return firstWord !== secondWord ? firstWord - secondWord : Number(nums[0]!.split('-')[0]) - Number(nextNum[0]!.split('-')[0]);
			});
		
		await this.setState({ size_chart, values });
		
	};
	
	render(props: SizeChartTableProps, state: SizeChartTableState) {
		const { size_chart } = state;
		return <div class="size-chart">
			<h2>Size chart for {props.product.name}</h2>
			{!size_chart && <Loading />}
			{size_chart && <table class="size-chart__table">
				<tbody>
					<tr>
						<th/>
						{size_chart.columns.map((col, i) => <th>{col}</th>)}
					</tr>
					{state.values && state.values.map(([word, nums]) => <tr>
						<td>{getSizeName(word)}</td>
						{size_chart.columns.map((col, i) => <td>{nums[i]}</td>)}
					</tr>)}
				</tbody>
			</table>}
		</div>;
	}
	
	async componentDidMount() {
		await this.getValues();
	}
	
}
